import { useCallback, useContext, useState } from 'react';
import { ApiClientContext } from 'common/contexts/api-client';
import type { ConsumerFailedPaymentModel } from './failed-payments.types';

const FAILED_PAYMENTS_ENDPOINT = '/v2/users/failed-payments';

type UseFailedPaymentsResult = {
  failedPayments: ConsumerFailedPaymentModel[];
  fetchFailedPayments: () => Promise<ConsumerFailedPaymentModel[]>;
};

export function useFailedPayments(): UseFailedPaymentsResult {
  const apiClient = useContext(ApiClientContext);
  const [failedPayments, setFailedPayments] = useState<
    ConsumerFailedPaymentModel[]
  >([]);

  const fetchFailedPayments = useCallback(async () => {
    try {
      const data = await apiClient.get(FAILED_PAYMENTS_ENDPOINT);
      const selfResolvableFailedPayments = (
        (data ?? []) as ConsumerFailedPaymentModel[]
      ).filter((item) => item.canSelfResolve);

      setFailedPayments(selfResolvableFailedPayments);

      return selfResolvableFailedPayments;
    } catch (err) {
      console.error(err);

      return [];
    }
  }, [apiClient]);

  return { failedPayments, fetchFailedPayments };
}
